/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function ReplayReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeReplayAction } action: action de
 *     l'application
 * @return { Reducer }
 */
export const ReplayReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeReplayAction) => {
      switch (action.type) {
        case actions.ReplayActionTypes.REPLAY_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.ReplayActionTypes.REPLAY_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.ReplayActionTypes.REPLAY_SUCCESS:

          return {
            data: action.payload.data, loading: false,
          }

          break;

        default:
          return state
          break;
      }
    }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/actions/replay/index.ts